import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/services/alert.service';
import { BookingService } from 'src/app/services/booking.service';
import { DivisionService } from 'src/app/services/division.service';
import { EventType } from 'src/enum/eventtype';

@Component({
  selector: 'app-sendbackpopup',
  templateUrl: './sendbackpopup.component.html',
  styleUrls: ['./sendbackpopup.component.scss']
})
export class SendbackpopupComponent implements OnInit {
  showNotes: boolean = true;  
  sentbackform:FormGroup;
  id: any;
  public eventEnum = EventType;
  sendbackDisabled: boolean;
  loading: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private router: Router,
    public dialogRef: MatDialogRef<SendbackpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedData: any,
    private bookingService: BookingService,
    public addServiceDialog: MatDialog,
  ) {
    this.id = this.dataRecievedData.id
  }


  ngOnInit(): void {
    this.showNotes = true;
    this.initializeValidators();
  }


  initializeValidators() {   
    this.sentbackform = this.formBuilder.group({
      sendbackremarks: [null, Validators.required]
    })
  }

  sendbackcancel(isProceed) {
    this.dialogRef.close(isProceed);

  }

  validateFormControl() {
    Object.keys(this.sentbackform.controls).forEach((field) => {
      const control = this.sentbackform.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }
  sendbackremarks(){
    this.sendbackDisabled = true;
    this.loading = true;
    if (this.sentbackform.valid) {
      let request = {
        id: this.id,
        eventType: this.eventEnum.ManufacturerSendBack,
        remarks: this.sentbackform.value.sendbackremarks,
      };
      this.bookingService
        .sendBack(request)
        .subscribe((res) => {
          if (res) {
            this.sendbackDisabled = false;
            this.loading = false;
            this.alertService.success('Manufacturer Send Back Successfully');
            this.dialogRef.close();
            this.router.navigate(["/aefarmerbooking"]);
            // this.router.navigate(['/eefarmerbookingapproval'])
          }
          else {
            this.sendbackDisabled = false;
            this.loading = false;
            // this.alertService.error(res.htmlFormattedFailures);
          }
        });
    } else {
      this.sendbackDisabled = false;
      this.loading = false;
      this.validateFormControl()
    }
  }
}
